module.exports = __webpack_public_path__ + "static/media/softwareworld-badge.fc7c4d94.png";